export default __webpack_public_path__ + "static/media/carousel-img-three.22643576.png";